import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import Select from 'react-select';
import './reactselect.scss';

class FormSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { options, placeholder, isSearchable, onChange, useTheme } = this.props;

    let useClassName = 'react-select-container';
    let useClassNamePrefix = 'react-select';

    if (useTheme === 'VT') {
      useClassName = 'vt-select-con';
      useClassNamePrefix = 'vt-select';
    }

    return (
      <Select
        className={useClassName}
        classNamePrefix={useClassNamePrefix}
        options={options}
        placeholder={placeholder}
        isSearchable={isSearchable}
        onChange={onChange}
      />
    );
  }
}

const mapStateToProps = (state) => ({});

export default withRouter(connect(mapStateToProps)(FormSelect));
